import api from "../../config/client.axios.api";

export const getResultApi = async () => {
  const response = await api.get(`/results`);
  return response.data;
};
